import { atom } from 'jotai';
import { useAtomValue } from 'jotai';
import jotaiStore from '../jotai-store.js';
export const selectedTenantId = atom();
export const setTenantId = (tenantId) => {
    if (tenantId) {
        localStorage.setItem('selectedTenantId', tenantId);
    }
    else {
        localStorage.removeItem('selectedTenantId');
    }
    jotaiStore.set(selectedTenantId, tenantId);
};
export const getTenantId = () => {
    return jotaiStore.get(selectedTenantId);
};
export const useTenantId = () => {
    return useAtomValue(selectedTenantId);
};
export const initTenantId = () => {
    let tenantId = localStorage.getItem('selectedTenantId');
    if (tenantId == null) {
        const ownerIds = localStorage.getItem('selectedOwners');
        if (ownerIds) {
            const parsed = JSON.parse(ownerIds);
            if (Array.isArray(parsed) && typeof parsed[0] === 'string') {
                tenantId = parsed[0];
            }
        }
    }
    if (tenantId != null) {
        setTenantId(tenantId);
    }
};
//# sourceMappingURL=selected.js.map